import * as React from 'react'
import { FC } from 'react'
import { ReducerProps } from '../reducer'
import { SortListItem } from './SortListItem'
import { GridApi } from '@mui/x-data-grid-pro'
import { SortListItemDisabled } from './SortListItemDisabled'
import {
  useDragData,
  DraggableItemWrapper,
  DropResult,
} from '@user/utils/Draggable'
import Box from '@mui/material/Box'

export const DragDrop: FC<
  ReducerProps & {
    apiRef: React.MutableRefObject<GridApi>
  }
> = (props) => {
  const { state, dispatch, apiRef } = props
  const { sortedColumns } = state

  const onDragEnd = React.useCallback(
    (result: DropResult) => {
      dispatch({ type: 'sort', payload: result })
    },
    [dispatch],
  )

  const columns = apiRef.current?.getAllColumns() || []

  const { containerRef, draggingIndex, itemRefs, offsets } = useDragData({
    dataList: sortedColumns,
    onDragEnd,
  })

  return (
    <>
      {sortedColumns?.map((column) => {
        const currentColumn = columns?.find((row) => row?.field == column.field)
        if (!currentColumn?.disableReorder || false) return null
        return (
          <SortListItemDisabled key={column.field} column={column} {...props} />
        )
      })}

      <Box ref={containerRef} id="columns">
        {sortedColumns.map((row, i) => {
          const currentColumn = columns?.find(
            (column) => column?.field == row.field,
          )
          if (currentColumn?.disableReorder || false) return null
          return (
            <DraggableItemWrapper
              key={i}
              ref={(el) => (itemRefs.current[i] = el as HTMLDivElement | null)}
              draggingIndex={draggingIndex}
              index={i}
              offsets={offsets}
              itemHeight="fit"
            >
              <SortListItem column={row} {...props} />
            </DraggableItemWrapper>
          )
        })}
      </Box>
    </>
  )
}
